import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface BusinessUnit {
  id: string;
  name: string;
  type: string;
  cnae: string | null;
  isActive: boolean;
}

interface BusinessUnitState {
  units: BusinessUnit[];
  activeUnitId: string | null; // null = "Visão Global" (all units)
  setUnits: (units: BusinessUnit[]) => void;
  setActiveUnit: (unitId: string | null) => void;
  getActiveUnit: () => BusinessUnit | null;
}

export const useBusinessUnitStore = create<BusinessUnitState>()(
  persist(
    (set, get) => ({
      units: [],
      activeUnitId: null,
      setUnits: (units: BusinessUnit[]) => set({ units }),
      setActiveUnit: (unitId: string | null) => {
        set({ activeUnitId: unitId });
        window.dispatchEvent(
          new CustomEvent('vsys:businessUnitChanged', { detail: { unitId } }),
        );
      },
      getActiveUnit: () => {
        const { units, activeUnitId } = get();
        if (!activeUnitId) return null;
        return units.find((u) => u.id === activeUnitId) || null;
      },
    }),
    {
      name: 'vsys-business-unit',
    },
  ),
);
